import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";
import publicityRoutes from "./publicity";
import ValidateAccountsRoute from "./validateAccount";
import userRoutes from "./users";
import profileRoutes from "./profile";
import tracker from "./tracker";
import peopleRoutes from "./people";
import configRoutes from "./config"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/permissoes",
        name: "apps-permissions-view",
        component: () => import("@/views/apps/rules/rulesView.vue"),
      }, 
      
      {
        path: "/visualizar/cadastro/:id",
        name: "apps-visualizar-cadastro",
        component: () => import("@/views/apps/liberacao-cadastros/visualizarCadastro.vue"),
      },

      {
        path: "/liberacao/cadastro",
        name: "apps-liberacao-view",
        component: () => import("@/views/apps/liberacao-cadastros/liberacaoCadastrosView.vue"),
      }

                   
    ],
  },
  profileRoutes,
  userRoutes,
  publicityRoutes,
  ValidateAccountsRoute,
  tracker,
  peopleRoutes,
  configRoutes,
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/login",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
